/* eslint-disable */
<template>
  <div class="login" id ="login">

    <NavigationBar>
      <template v-slot:left>
        <img v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg">
      </template>
      <template v-slot:center>
        {{ $t('login_user.title') }}
      </template>
      <template v-slot:right>
      </template>
    </NavigationBar>

    <div class="vld-parent">
      <loading :active.sync="isLoading"
               :can-cancel="false"
               :color="betgamePrimaryColor"
               :opacity="opacity"
               :is-full-page="isFullPage">
        <div style="margin-bottom: 20px; font-size: 18pt;" slot="before">{{ $t('login_user.loading_user_data') }}</div>
      </loading>
    </div>

    <!--
    <div class="swiper" id="swiper_container">
      <WelcomeSwiper></WelcomeSwiper>
    </div>
    -->

    <div>
      <h1>{{ $t('login_user.welcome_title') }}</h1>
      <p>{{ $t('login_user.welcome_text') }}</p>
    </div>

    <!-- Single Sign On -->
    <div class="single-sign-on">
      
      <!-- Apple -->
      <div v-if="!isAndroidApp" class="single-sign-on__button">
        <input v-model="appleLogin" type="checkbox" id="appleLogin" name="appleLogin" @change="loginTypeChecked($event)" />
        <label for="appleLogin" class="single-sign-on__button__content">
          <img src="../assets/icons/ic_20_apple.svg">{{ $t('register.login_with_apple') }}
        </label>
      </div>

      <!-- Google -->
      <div v-if="isAndroidApp" class="single-sign-on__button">
        <input v-model="googleLogin" type="checkbox" id="googleLogin" name="googleLogin" @change="loginTypeChecked($event)" />
        <label for="googleLogin" class="single-sign-on__button__content">
          <img src="../assets/icons/ic_20_google.svg">{{ $t('register.login_with_google') }}
        </label>
      </div>
      <div v-else style="display: flex; justify-content: center;">
        <div id="g_id_onload"
             data-client_id="943145692537-elvlet8tq780g58j60gn8vb130m79eq0.apps.googleusercontent.com"
             data-context="signin"
             data-ux_mode="popup"
             data-callback="handleGoogleLogin"
             data-auto_select="true"
             data-itp_support="true">
        </div>

        <div class="g_id_signin" style="text-align: center"
             data-type="standard"
             data-shape="rectangular"
             data-theme="outline"
             data-text="signin_with"
             data-size="large"
             data-width="300"
             data-logo_alignment="left">
        </div>
      </div>
      <!--<GoogleLogin @login-success="onLoginSuccess" style="width: 100%;"/>-->
    </div>

    <!-- Divider -->
    <div class="single-sign-on__divider">
      <div></div>
      <span style="text-transform: uppercase">{{ $t('or') }}</span>
      <div></div>
    </div>
    
    <form @submit.prevent="login">

      <div class="input-container">

        <div>
          <div class="input-element">
            <input v-model="email" type="email" name="email" id="email" placeholder="email" value />
            <label for="email">{{ $t('email') }}</label>
          </div>

          <div class="input-element">
            <input v-model="password" type="password" name="password" id="password" placeholder="password" value />
            <label for="password">{{ $t('password') }}</label>
          </div>
        </div>

        <div class="input-button-row">
          <button type="submit" name="button">
            {{ $t('login') }}
          </button>
        </div>

      </div>
    </form>
    
    <!-- <button v-on:click="callJSString">JavaScript</button> -->
    
    <div class="forgot-password">
      <span>{{ $t('login_user.user_not_registered') }}</span>
      <router-link to="/register">{{ $t('login_user.register_now') }}</router-link>
    </div>
    <div class="forgot-password">
      <span>{{ $t('login_user.start_betgame') }}</span>
      <router-link to="/createuserbetgame">{{ $t('login_user.start_betgame_now') }}</router-link>
    </div>
    <!--
    <div class="forgot-password">
      <span>{{ $t('login_user.validation_code_received') }}</span>
      <router-link to="/validateregistration">{{ $t('login_user.enter_validation_code') }}</router-link>
    </div>
    -->
    <div class="forgot-password">
      <span>{{ $t('forgot_password') }}</span>
      <router-link to="/resetpassword">{{ $t('reset_password') }}</router-link>
    </div>

  </div>
</template>

<script>
import NavigationBar from './../components/NavigationBar'
import WelcomeSwiper from '../components/WelcomeSwiper'
import { bootstrap } from 'vue-gtag'
import Loading from 'vue-loading-overlay'
import Numeral from 'numeral'
import moment from 'moment'
import Vue from 'vue'
import GoogleLogin from '../components/GoogleLogin.vue'

export default {
  components: {
    NavigationBar,
    WelcomeSwiper,
    Loading,
    GoogleLogin
  },
  data() {
    return {
      email: '',
      password: '',
      action: '',
      isLoading: false,
      opacity: 0.9,
      isFullPage: true,
      betgameToJoin: '',
      appleLogin: false,
      googleLogin: false
    }
  },
  metaInfo: {
    title: 'Login',
    meta: [
      { vmid: 'keywords', name: 'keywords', content: 'Login, Registrieren, Passwort Zurücksetzen, Anmelden, Registrierungs-Code erhalten' },
      { vmid: 'description', name: 'description', content: 'Login' },
    ]
  },
  mounted() {
    const e = localStorage.getItem('logine')
    const p = localStorage.getItem('loginp')
    if(e && e.trim().length > 1 && e !== 'null' && e !== 'undefined' &&
        p && p.trim().length > 1 && p !== 'null' && p !== 'undefined') {
      this.email = e
      this.password = p
    } else {
      if(e && e.trim().length > 1 && e !== 'null' && e !== 'undefined') {
        this.email = e
      } else {
        this.email = ''
        localStorage.removeItem('logine')
      }
      this.password = ''
      localStorage.removeItem('loginp')
    }

    window.addEventListener('google-auth', this.onGoogleAuth);
    window.addEventListener('google-signout', this.onGoogleSignout);
    
    window.handleGoogleLogin = function(token) {
      if(token) {
        if(token.credential) {
          window.localStorage.setItem('gatoken', token.credential)
          window.location.href = '/googleauth?token=' + token.credential
        } else {
          window.localStorage.setItem('gatoken', token)
          window.location.href = '/googleauth?token=' + token    
        }
      } else {
        alert('Login with Google failed: 0004')
      }
      
      //alert("ID token from native iOS app: " + token.length)
      //alert("googleSigninToken ")
      //const t = window.localStorage.getItem("googleSigninToken")
      //alert("googleSigninToken " + t)
      //this.verifyTokenWithBackend(token.credential)
      //const user = this.parseJwt(token.credential)
      //alert("LoginUser Logged in user:" +  user.email + user.sub + user.name)
    }
  },
  beforeDestroy() {
    window.removeEventListener('google-auth', this.onGoogleAuth);
    window.removeEventListener('google-signout', this.onGoogleSignout);
  },
  created() {
    const a = this.getBGValue('betgameAction')
    const b = this.getBGValue('spmbgid')
    this.$log.debug('LoginUser created ' + a + ' --- ' + b + ' --- ' + JSON.stringify(this.$route.params))
    this.$store.dispatch('clearDataBeforeLogin')
    .then(() => {
      if(this.$route.query.email) {
        this.email = this.$route.query.email
      } else if(this.$route.params.email) {
        this.email = this.$route.params.email
      }
      if(this.$route.params.action) {
        this.action = this.$route.params.action
        this.$log.debug('LoginUser.created action ' + this.action)
      } else if(a && a === 'invitation') {
        this.action = 'join'
        this.$log.debug('LoginUser.created action invitation ' + b)
      }
      if(this.$route.params.betgame) {
        this.betgameToJoin = this.$route.params.betgame
        this.$log.debug('LoginUser.created betgame ' + this.betgameToJoin)
      } else if(b && parseInt(b) > 0) {
        this.betgameToJoin = b
        this.$log.debug('LoginUser.created betgameToJoin ' + b)
      }
    }).catch(error => {
    })
    if(!this.isAndroidApp) {
      const lureloaded = localStorage.getItem('lureloaded');
      if (lureloaded !== 'true') {
        localStorage.setItem('lureloaded', 'true');
        location.reload();
      }
    }
  },
  computed: {
    betgamePrimaryColor() {
      if(this.$store.state.betgame && this.$store.state.betgame.primary_color && this.$store.state.betgame.primary_color.length > 0) {
        return this.$store.state.betgame.primary_color
      }
      return '#000000'
    },
    isAndroidApp() {
      return window.AndroidBridge && window.AndroidBridge.signInWithGoogle
    }
  },
  watch: {
    email: {
      handler: function() {
        localStorage.setItem('logine', this.email)
      },
      deep: true
    },
    password: {
      handler: function() {
        localStorage.setItem('loginp', this.password)
      },
      deep: true
    }
  },
  methods: {
    getNotificationPreferences() {
      var notification_preferences = ''
      if(this.$store.state.user) {
        if(this.$store.state.user.email_notifications !== undefined && this.$store.state.user.email_notifications === true) {
          notification_preferences += 'MReminder,'
        }
        if(this.$store.state.user.push_notifications !== undefined && this.$store.state.user.push_notifications === true) {
          notification_preferences += 'PReminder,'
        }
        if(this.$store.state.user.news_email_notifications !== undefined && this.$store.state.user.news_email_notifications === true) {
          notification_preferences += 'MNews,'
        }
        if(this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) {
          notification_preferences += 'PNews,'
        }
        if(this.$store.state.user.chat_push_notifications !== undefined && this.$store.state.user.chat_push_notifications === true) {
          notification_preferences += 'PChat,'
        }
      }
      if(notification_preferences === '') {
        notification_preferences = 'none'
      }
      return notification_preferences
    },
    googleSignIn() {
      // If running inside the Android WebView, call the bridge.
      if (window.AndroidBridge && window.AndroidBridge.signInWithGoogle) {
        window.AndroidBridge.signInWithGoogle();
      } else {
        // Fallback if opened in a normal browser:
        // redirect to your backend’s OAuth start, which should use Google OAuth on web.
        alert('Login with Google failed: 0001')
        // window.location.href = '/auth/google/start';
      }
    },
    async onGoogleAuth(e) {
      const { ok, idToken, error } = e.detail || {};
      if (!ok) {
        alert('Google sign-in failed. ' + error);
        return;
      }

      // Send token to your backend to verify and create a session
      try {
        const res = await fetch('https://teamtip.net/auth/google', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: new URLSearchParams({
            credential: idToken,
            clienttype: 'android',
          })
        });

        alert(res.text())
        
        // You could store session here, or redirect, etc.
      } catch (err) {
        Vue.$log.debug("GoogleAuth Failed to verify token:", err)
        return 'Login failed ' + err.message
      }
    },
    googleSignout() {
      if (window.AndroidBridge && window.AndroidBridge.signOutGoogle) {
        window.AndroidBridge.signOutGoogle();
      }
    },
    onGoogleSignout() {
      // clear local session state if needed
    },
    startGoogleLogin() {
      try {
        if (window.webkit && window.webkit.messageHandlers.TeamtipAppInterface !== undefined && window.webkit.messageHandlers.TeamtipAppInterface !== null) {
          window.webkit.messageHandlers.TeamtipAppInterface.postMessage('loginWithGoogle')
        } else {
          this.googleSignIn()
        } 
      } catch (e) {
        alert("Native login not failed " + e)
      }
    },
    onLoginSuccess (user) {
      Vue.$log.debug('LoginUser onLoginSuccess: ', user.email, user.sub, user.name)
      const eid = user.sub
      const email = user.email
      const pwd = eid.slice(1, -1)
      Vue.$log.debug('LoginUser mounted ' + ' --- ' + eid + ' --- ' + email)
      this.$store.dispatch('login', {
        email: String(email).toLowerCase(),
        pass: pwd
      }).then((res) => {
        Vue.$log.debug('LoginUser onLoginSuccess ' + JSON.stringify(this.$store.state.user))
        if(this.$store.state.betgame) {
          this.$router.push('/mybetgames') 
        } else {
          if(res && (res > 0 || parseInt(res) > 0)) {
            this.$store.dispatch('switchBetgame', res).then(() => {
              this.$router.push('/feed/dashboard')
            })
          } else {
            this.$router.push('/searchbetgame')
          }
        }
      })
    },
    loginTypeChecked(event) {
      if(event.target.id === 'appleLogin') {
        this.appleLogin = event.target.checked
        if(this.appleLogin) {
          this.googleLogin = false
        }
        this.loginApple()
      } else if(event.target.id === 'googleLogin') {
        this.googleLogin = event.target.checked
        if(this.googleLogin) {
          this.appleLogin = false
        }
        this.startGoogleLogin()
      }
    },
    loginApple () {
      window.localStorage.setItem('betgameAction', 'login')
      const clientId = 'net.teamtip.app'; // Deine Service-ID von Apple
      const redirectURI = 'https://teamtip.net/auth/apple'; // Backend Redirect
      const url = `https://appleid.apple.com/auth/authorize?` +
        `response_type=code%20id_token` +
        `&client_id=${encodeURIComponent(clientId)}` +
        `&redirect_uri=${encodeURIComponent(redirectURI)}` +
        `&scope=name%20email` +
        `&response_mode=form_post`;
      window.location.href = url;
    },
    loginGoogle () {
    },
    callJSString() {
      try {
        if (window.TeamtipAppInterface !== undefined && window.TeamtipAppInterface !== null) {
          const a = window.TeamtipAppInterface.getPushToken()
        } else if (window.webkit && window.webkit.messageHandlers.TeamtipAppInterface !== undefined && window.webkit.messageHandlers.TeamtipAppInterface !== null) {
          const b = window.webkit.messageHandlers.TeamtipAppInterface.postMessage('getPushToken')
          const c = window.localStorage.getItem('pushToken')
        } else {
        }
      } catch (e) {
      }
    },
    sendLogin() {
      try {
        if (window.TeamtipAppInterface !== undefined && window.TeamtipAppInterface !== null) {
          const a = window.TeamtipAppInterface.login()
        } else if (window.webkit && window.webkit.messageHandlers.TeamtipAppInterface !== undefined && window.webkit.messageHandlers.TeamtipAppInterface !== null) {
          const b = window.webkit.messageHandlers.TeamtipAppInterface.postMessage('login')
          if(this.isSPMUser()) {
            const c = window.webkit.messageHandlers.TeamtipAppInterface.postMessage({
              'user': this.$store.state.user.id,
              'token': this.$store.state.token,
            })
          }
        } else {
        }
      } catch (e) {
      }
    },
    goBack () {
      this.password = ''
      localStorage.removeItem('loginp')
      this.$router.push({ name: 'home' }).catch(err => {
      })
    },
    login() {
      if(!this.email || this.email.trim() === '') {
        const	email_input = document.getElementById('email')
        const temp = email_input.value
        if(temp && temp.trim().length > 1) {
          this.email = temp
        }
      }
      if(!this.password || this.password.trim() === '') {
        const	password_input = document.getElementById('password')
        const temp = password_input.value
        if(temp && temp.trim().length > 1) {
          this.password = temp
        }
      }
      if(!this.email || this.email.trim() === '') {
        alert(this.$i18n.t('errors.email_or_password_wrong'))
      } else if(!this.password || this.password.trim() === '') {
        alert(this.$i18n.t('errors.email_or_password_wrong'))
      } else if(this.email && this.password) {
        this.isLoading = true
        const that = this
        this.$store.dispatch('login', {
          email: String(this.email).toLowerCase(),
          pass: this.password
        }).then((res) => {
          localStorage.removeItem('loginp')
          if(this.$store.state.language !== undefined && this.$store.state.language !== null &&
              this.$store.state.language.length > 1) {
            Numeral.locale(this.$store.state.language)
            moment.locale(this.$store.state.language)
          }
          if(this.$store.state.language !== undefined && this.$store.state.language !== null &&
              this.$store.state.language.length > 1 && this.$i18n.locale !== this.$store.state.language) {
            this.$i18n.locale = this.$store.state.language
          }
          this.sendLogin()
          bootstrap().then(gtag => {
            this.$gtag.set({
              'user_id': this.$store.state.user ? '' + this.$store.state.user.id : '',
              'anonymize_ip': true,
              'dimension1': this.$store.state.betgame && this.$store.state.betgame.name ? this.$store.state.betgame.name : 'betgame not set',
              'dimension2': this.$store.state.user && this.$store.state.user.source ? this.$store.state.user.source : 'user source not set',
              'dimension3': this.$store.state.betgame && this.$store.state.betgame.id ? this.$store.state.betgame.id : 'betgame id not set',
              'dimension5': this.$store.state.betgame && this.$store.state.betgame.type ? this.$store.state.betgame.type : 'betgame type not set'
            })
            if(this.$store.state.betgame && this.$store.state.user) {
              this.$gtag.set({
                user_properties: {
                  permission_manage_prediction_round: '' + this.isAdmin(this.$store.state.betgame.id),
                  prediction_mode: this.getBetgameType(this.$store.state.betgame),
                  prediction_competiton: this.getCompetitionId(this.$store.state.betgame.id),
                  betgame_id: '' + this.$store.state.betgame.id,
                  notification_preferences: this.getNotificationPreferences(), 
                  news_push: (this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) ? '1' : '0',
                  user_age: (this.$store.state.user.isadult) ? '>=18' : '<18',
                  test_spm: (this.isSPMUser()) ? '1' : '0'
                },
              })
            }
            this.$gtag.config({ user_id: this.$store.state.user ? '' + this.$store.state.user.id : '' })
            /*
          this.$gtag.event('login', {
            'event_category': 'login',
            'event_label': window.location.href,
            'anonymize_ip': true,
            'dimension1': this.$store.state.betgame && this.$store.state.betgame.name ? this.$store.state.betgame.name : 'betgame not set',
            'dimension2': this.$store.state.user && this.$store.state.user.source ? this.$store.state.user.source : 'user source not set',
            'dimension3': this.$store.state.betgame && this.$store.state.betgame.id ? this.$store.state.betgame.id : 'betgame id not set'
          })
          */
          })
          this.$log.debug("LoginUser: " + this.action + ' --- ' + this.betgameToJoin + ' ---- ' + JSON.stringify(res))
          if(res && res > 0) {
            if(this.action === 'join' && this.betgameToJoin !== '') {
              this.$store.dispatch('userEnterBetgame', this.betgameToJoin).then(() => {
                this.$store.dispatch('switchBetgame', this.betgameToJoin).then(() => {
                  this.$router.push({ name: 'dashboard' })
                })
              })
            } else {
              this.$store.dispatch('switchBetgame', res).then(() => {
                this.$router.push({ name: 'dashboard' })
              })
            }
          } else if(this.$store.state.betgameId) {
            this.$store.dispatch('switchBetgame', this.$store.state.betgameId).then(() => {
              this.$router.push({ name: 'dashboard' })
            })
          } else if(this.$store.state.user && this.$store.state.user.fk_betgame) {
            this.$store.dispatch('switchBetgame', this.$store.state.user.fk_betgame).then(() => {
              this.$router.push({ name: 'dashboard' })
            })
          } else {
            this.$router.push('/mybetgames')
          }
        }).catch(function (error) {
          that.password = ''
          localStorage.removeItem('loginp')
          if (error.response && error.response.status === 403) {
            alert(that.$i18n.t('errors.email_or_password_wrong'))
          } else {
            alert(that.$i18n.t('errors.login_error') + ' ' + error)
          }
        }).finally(function () {
          that.isLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .login {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 16px 0 16px;
    max-width: 400px;
    margin: 32px auto;

    h1 {
      text-align: center;
    }
    p {
      text-align: center;
      margin-bottom: 26px;
    }
  }

  .input-container {
    margin: 0 auto;
  }

  .forgot-password {
    width: 100%;
    text-align: center;
    color: var(--color-text);
    padding: 21px 0 0;

    a {
      font-weight: 500;
      text-decoration: none;
      margin-left: 6px;
      padding: 12px 0;
    }
  }

  @media screen and (max-width: 414px) {
    .swiper {
      margin: 16px 0;
    }
  }

  .single-sign-on {

    &__divider {
      display: flex;
      align-items: center;
      width: 100%;
      margin: 24px 0;

      span {
        font-size: 14px;
        color: rgba(var(--color-text-rgb), .48);
        margin: 0 8px;
      }

      div {
        height: 1px;
        width: 100%;
        background: linear-gradient(90deg, var(--color-text) 0%, rgba(var(--color-text-rgb), 0) 100%);
        opacity: .12;

        &:first-of-type {
          background: linear-gradient(90deg, rgba(var(--color-text-rgb), 0) 0%, var(--color-text) 100%);
        }
      }
    }

    &__button {
      display: flex;
      width: 100%;

      &:not(:last-child) {
        margin-bottom: 8px;
      }

      &__content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background: var(--color-surface);
        border-radius: 8px;
        padding: 16px;
        font-size: 17px;
        color: var(--color-text);
        box-shadow: 0 0 0 1px rgba(var(--color-text-rgb), .08);
        transition: all .2s ease-in-out;

        &:hover {
          box-shadow: 0 0 0 1px rgba(var(--color-text-rgb), .16);
        }

        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }

      input {
        display: none;

        &:checked ~ label {
          box-shadow: 0 0 0 2px var(--color-primary);
        }
      }
    }
  }  
</style>
